module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.9-122.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.9.md
// module id = 539
// module chunks = 267